import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateQuickFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 436,
	height: 436,
	viewBox: "0 0 436 436",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M233.069 418.474C332.276 418.474 412.7 338.05 412.7 238.843C412.7 139.635 332.276 59.2111 233.069 59.2111C133.861 59.2111 53.437 139.635 53.437 238.843C53.437 338.05 133.861 418.474 233.069 418.474Z",
			fill: "#EBF3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M261.511 68.1318C268.929 66.6947 276.125 71.5475 277.573 78.9649L320.563 300.105C322 307.523 317.148 314.719 309.73 316.167L160.288 345.217C152.87 346.655 145.674 341.802 144.226 334.384L101.236 113.244C99.7989 105.827 104.652 98.6304 112.069 97.1823L261.511 68.1318ZM258.726 53.7723L109.283 82.8229C93.9291 85.8075 83.9029 100.675 86.8875 116.019L129.878 337.159C132.862 352.513 147.73 362.54 163.084 359.555L312.527 330.504C327.881 327.52 337.907 312.652 334.923 297.308L291.933 76.1682C288.948 60.8139 274.08 50.7877 258.726 53.7723Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M261.511 68.1319C268.929 66.6948 276.125 71.5476 277.573 78.965L320.563 300.105C322 307.523 317.148 314.719 309.73 316.167L160.288 345.218C152.87 346.655 145.674 341.802 144.226 334.384L101.236 113.244C99.7989 105.827 104.652 98.6305 112.069 97.1824L261.511 68.1319Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M149.753 162.601C160.602 162.601 169.396 153.807 169.396 142.958C169.396 132.109 160.602 123.315 149.753 123.315C138.904 123.315 130.109 132.109 130.109 142.958C130.109 153.807 138.904 162.601 149.753 162.601Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M183.844 127.526L217.04 121.071",
			stroke: "#DCEBFE",
			strokeWidth: 5.61556,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M187.371 145.688L259.4 131.683",
			stroke: "#DCEBFE",
			strokeWidth: 5.61556,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M163.759 234.686C174.607 234.686 183.402 225.891 183.402 215.043C183.402 204.194 174.607 195.399 163.759 195.399C152.91 195.399 144.115 204.194 144.115 215.043C144.115 225.891 152.91 234.686 163.759 234.686Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M197.85 199.611L231.046 193.155",
			stroke: "#DCEBFE",
			strokeWidth: 5.61556,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M201.387 217.773L273.406 203.767",
			stroke: "#DCEBFE",
			strokeWidth: 5.61556,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M177.775 306.771C188.624 306.771 197.419 297.976 197.419 287.128C197.419 276.279 188.624 267.484 177.775 267.484C166.926 267.484 158.132 276.279 158.132 287.128C158.132 297.976 166.926 306.771 177.775 306.771Z",
			fill: "#3F8BFD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M211.867 271.696L245.063 265.24",
			stroke: "#3F8BFD",
			strokeWidth: 5.61556,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M215.393 289.858L287.423 275.852",
			stroke: "#3F8BFD",
			strokeWidth: 5.61556,
			strokeMiterlimit: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M143.22 145.556L148.946 149.414L157.082 137.354",
			stroke: "white",
			strokeWidth: 4.1564,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M157.137 217.132L162.863 221.001L170.999 208.93",
			stroke: "white",
			strokeWidth: 4.1564,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M171.253 289.758L176.98 293.616L185.115 281.556",
			stroke: "white",
			strokeWidth: 4.1564,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M327.439 205.835C329.727 205.835 332.049 206.034 334.337 206.409C356.921 210.179 372.22 231.613 368.461 254.197C366.836 263.947 361.774 272.812 354.212 279.146C346.729 285.425 337.266 288.885 327.572 288.885C325.283 288.885 322.951 288.686 320.674 288.31C309.73 286.486 300.157 280.506 293.713 271.486C287.268 262.465 284.725 251.467 286.549 240.523C288.174 230.773 293.237 221.907 300.798 215.573C308.282 209.295 317.744 205.835 327.439 205.835Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M343.435 181.646L333.796 180.038L332.034 190.603L341.673 192.211L343.435 181.646Z",
			fill: "#9AEDE6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M352.314 170.177L329.089 166.303C327.15 165.98 325.316 167.29 324.992 169.229L323.772 176.545C323.449 178.484 324.758 180.318 326.697 180.642L349.922 184.516C351.861 184.839 353.695 183.529 354.019 181.59L355.239 174.274C355.563 172.335 354.253 170.501 352.314 170.177Z",
			fill: "#9AEDE6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M377.299 201.229L382.521 207.338C383.592 208.59 383.437 210.467 382.194 211.53L375.985 216.839L366.89 206.202L373.099 200.893C374.351 199.823 376.229 199.978 377.292 201.221L377.299 201.229Z",
			fill: "#9AEDE6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M327.439 205.835C329.727 205.835 332.049 206.034 334.337 206.409C356.921 210.179 372.22 231.613 368.461 254.197C366.836 263.947 361.773 272.812 354.212 279.146C346.729 285.425 337.266 288.885 327.572 288.885C325.283 288.885 322.951 288.686 320.674 288.31C309.73 286.486 300.157 280.506 293.712 271.486C287.268 262.465 284.725 251.466 286.549 240.523C288.174 230.773 293.237 221.907 300.798 215.573C308.282 209.295 317.744 205.835 327.439 205.835ZM327.428 189.076C299.461 189.076 274.765 209.272 270.012 237.77C264.717 269.518 286.162 299.552 317.91 304.847C321.16 305.389 324.388 305.654 327.572 305.654C355.539 305.654 380.234 285.458 384.987 256.96C390.282 225.213 368.837 195.178 337.089 189.883C333.839 189.342 330.611 189.076 327.428 189.076Z",
			fill: "#9AEDE6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332.9 214.999C332.9 214.999 332.878 214.999 332.866 214.999L329.97 232.343C329.97 232.343 329.992 232.343 330.003 232.343C338.294 233.725 343.91 241.595 342.528 249.875C341.146 258.165 333.275 263.781 324.996 262.399C316.705 261.017 311.09 253.147 312.471 244.867C312.814 242.789 313.566 240.888 314.638 239.219L300.909 229.579L301.483 227.39C298.289 231.525 296.045 236.477 295.127 241.982C292.154 259.835 304.247 276.781 322.1 279.754C339.952 282.728 356.898 270.635 359.872 252.782C362.846 234.929 350.752 217.983 332.9 215.01V214.999Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M300.909 229.568L327.339 248.128",
			stroke: "#002F75",
			strokeWidth: 5.5824,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M327.395 254.705C331.1 254.705 334.104 251.701 334.104 247.995C334.104 244.29 331.1 241.286 327.395 241.286C323.689 241.286 320.685 244.29 320.685 247.995C320.685 251.701 323.689 254.705 327.395 254.705Z",
			fill: "#002F75"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M181.39 19.7695C181.412 20.3222 181.202 20.8749 180.815 21.2618L166.876 35.2123C166.522 35.566 166.069 35.8092 165.583 35.8534C164.986 35.8976 164.422 35.6987 164.013 35.2786L158.01 29.2761C157.612 28.8782 157.402 28.3365 157.436 27.7838C157.458 27.2311 157.723 26.7005 158.154 26.3468C158.928 25.7056 160.122 25.783 160.862 26.5236L165.384 31.0448C165.384 31.0448 165.439 31.0669 165.45 31.0448L177.985 18.5093C178.726 17.7687 179.909 17.6913 180.694 18.3324C181.125 18.6862 181.379 19.2168 181.412 19.7695H181.39Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M251.408 371.914C251.43 372.466 251.22 373.019 250.833 373.406L236.893 387.356C236.54 387.71 236.086 387.953 235.6 387.997C235.003 388.042 234.439 387.843 234.03 387.423L228.028 381.42C227.63 381.022 227.42 380.481 227.453 379.928C227.475 379.375 227.741 378.845 228.172 378.491C228.945 377.85 230.139 377.927 230.88 378.668L235.401 383.189C235.401 383.189 235.456 383.211 235.467 383.189L248.003 370.653C248.744 369.913 249.926 369.835 250.711 370.476C251.142 370.83 251.397 371.361 251.43 371.914H251.408Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.7095 283.867C84.7537 284.718 84.4221 285.558 83.8252 286.166L62.4021 307.589C61.8604 308.131 61.164 308.506 60.4123 308.573C59.5058 308.65 58.6326 308.33 58.0025 307.688L48.7722 298.458C48.1642 297.85 47.8436 297.01 47.8878 296.159C47.932 295.308 48.33 294.501 48.9933 293.959C50.1871 292.975 52.0111 293.086 53.1496 294.224L60.1028 301.177C60.1028 301.177 60.1801 301.211 60.2133 301.177L79.4698 281.921C80.6084 280.782 82.4213 280.672 83.6262 281.656C84.2895 282.208 84.6874 283.004 84.7316 283.867H84.7095Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M88.1477 169.267C82.101 170.185 76.3639 165.409 74.0867 159.738C73.5008 158.279 73.1913 156.599 73.0255 154.786C72.2849 146.727 74.2857 136.204 66.415 132.622C63.1098 131.119 59.0861 132.114 56.1125 134.192C53.1278 136.27 50.8286 139.199 48.8056 142.228C25.2601 177.502 3.27319 178.276 2.3999 177.182C2.44412 177.248 2.49939 177.303 2.54361 177.37C7.45169 183.428 15.5766 185.859 23.0382 183.593C25.4701 182.864 27.8578 181.913 30.1792 180.763C36.9334 177.425 43.1016 172.373 47.7002 165.862C44.6713 173.236 39.6085 179.968 33.1197 185.263C29.8808 187.916 26.2771 190.215 22.397 192.072C22.3418 192.094 22.2865 192.116 22.2423 192.149C24.7516 193.233 27.3493 194.128 30.0024 194.813C36.1043 196.394 42.6263 194.913 47.3686 190.768C47.3907 190.745 47.4238 190.723 47.446 190.701C53.1057 185.727 57.7596 179.26 60.5231 171.787C59.5061 179.691 56.3446 187.507 51.4476 194.294C51.0496 194.847 50.6296 195.399 50.2095 195.941C66.0503 193.542 80.5866 183.405 88.1698 169.267H88.1477Z",
			fill: "#6BA6FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M308.392 118.351C314.494 118.097 319.226 112.316 320.375 106.313C320.674 104.777 320.652 103.063 320.464 101.25C319.657 93.1917 315.688 83.254 322.73 78.2353C325.692 76.124 329.827 76.334 333.143 77.8042C336.47 79.2744 339.289 81.7064 341.843 84.2931C371.689 114.438 393.411 110.989 394.063 109.751C394.03 109.817 393.985 109.895 393.952 109.961C390.293 116.848 382.776 120.772 375.027 119.987C372.507 119.733 369.976 119.258 367.477 118.572C360.215 116.583 353.195 112.791 347.436 107.286C351.814 113.941 358.07 119.589 365.454 123.547C369.147 125.536 373.115 127.106 377.282 128.178C377.338 128.189 377.393 128.201 377.448 128.223C375.193 129.77 372.806 131.141 370.34 132.324C364.659 135.043 357.971 134.833 352.521 131.661C352.488 131.638 352.466 131.627 352.433 131.605C345.922 127.803 340.118 122.342 335.984 115.532C338.493 123.093 343.092 130.157 349.194 135.894C349.691 136.359 350.211 136.823 350.73 137.276C334.724 137.95 318.518 130.765 308.381 118.329L308.392 118.351Z",
			fill: "#6BA6FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M434.378 140.88C434.4 141.433 434.19 141.985 433.803 142.372L419.864 156.323C419.51 156.676 419.057 156.92 418.57 156.964C417.973 157.008 417.41 156.809 417.001 156.389L410.998 150.386C410.6 149.989 410.39 149.447 410.423 148.894C410.445 148.341 410.711 147.811 411.142 147.457C411.916 146.816 413.11 146.893 413.85 147.634L418.371 152.155C418.371 152.155 418.427 152.177 418.438 152.155L430.973 139.62C431.714 138.879 432.897 138.802 433.681 139.443C434.113 139.797 434.367 140.327 434.4 140.88H434.378Z",
			fill: "#DCEBFE"
		})
	]
});
export default SvgEmptyStateQuickFill;
